import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";
import { throwIfHasNoPermission } from "@/utils/permissions";

import HandbookList from "@/modules/handbook/admin/components/HandbookList";
import { fetchEntriesQueryOptions } from "@/modules/handbook/admin/services";

export const Route = createFileRoute("/admin/_panel/_handbook/handbook/")({
  component: Component,
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(context.user, "handbook.handbook-entry.view");

    return {
      crumb: [
        {
          label: context.t("Handbook", { ns: "handbook.shared" }),
        },
      ],
    };
  },
  loader: (opts) =>
    opts.context.queryClient.prefetchQuery(fetchEntriesQueryOptions()),
});

function Component() {
  const { t } = useTranslation("handbook.admin");

  return (
    <Container
      title={t("Handbook", {
        ns: "handbook.shared",
      })}
      description={t("Manage Handbook")}
    >
      <HandbookList />
    </Container>
  );
}
